<script lang="ts" setup>
import ParagrahNote from '../../ParagrahNote.vue';
import WhereToConsultCard from '../../WhereToConsult/WhereToConsultCard.vue';
import AverageWeddingExpensesImg from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/marriageCost/WhereToConsultCard/01_average_wedding_expenses.png/01_average_wedding_expenses.webp';
import ConjunctionsImg from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/marriageCost/WhereToConsultCard/02_conjunctions.png/02_conjunctions.webp';
import WeddingExpensesImg from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/marriageCost/WhereToConsultCard/03_wedding_expenses.png/03_wedding_expenses.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  imageNumber: number;
}>();
</script>

<template>
  <WhereToConsultCard
    title="結婚資金の平均は約523万円"
    :image-number="imageNumber"
  >
    <p>
      ゼクシィの調査によると、結納から新婚旅行までにかかった資金の総額の平均が470万円、新生活でインテリア・家具および家電製品購入にかかった費用の平均額の合計が53.2万円です。
    </p>
    <p>これらを単純に合計すると、結婚資金総額の平均は約523万円となります。</p>

    <PinchImageModal :src="AverageWeddingExpensesImg" alt="結婚費用の平均額" />
    <ParagrahNote>
      ※「結納・顔合わせ」「婚約・結婚指輪」はそれぞれの平均額の合計<br />
      ※「新婚旅行」は土産代を含む<br />
      ※「結納・婚約～新婚旅行までにかかった費用総額」の算出時に用いた各項目の平均金額を掲載しているが、これは結納・会場費および両家の顔合わせ・会場費については実施した人の、その他の項目については費用の発生した人の平均金額であり、各項目の平均金額の合計は、「結納・婚約～新婚旅行までにかかった費用総額」とは一致しない<br />
      [参照]<br />
      ※1：<NuxtLink
        href="https://souken.zexy.net/data/trend2023/XY_MT23_report_06shutoken.pdf"
        external
        target="_blank"
        >ゼクシィ結婚トレンド調査2023首都圏 全国（推計値）</NuxtLink
      ><br />
      ※2：<NuxtLink
        href="https://souken.zexy.net/data/trend2023/XY_ML23_release.pdf#page=7"
        external
        target="_blank"
        >新婚生活実態調査2023（リクルートブライダル総研調べ）P7</NuxtLink
      >
    </ParagrahNote>
    <h3>結納・顔合わせの費用：平均27.3万円</h3>
    <p>
      食事を含めた結納式の平均費用は20.6万円、食事を含めた両家の顔合わせの平均費用は6.7万円です。
    </p>
    <p>
      ただし、結納式・両家の顔合わせのどちらかだけを行うケースや、いずれも行わないケースも珍しくありません。
    </p>
    <PinchImageModal
      :src="ConjunctionsImg"
      alt="結納・両家の顔合わせの実施割合"
    />
    <ParagrahNote>
      参照：<NuxtLink
        href="https://souken.zexy.net/data/trend2023/XY_MT23_report_06shutoken.pdf"
        external
        target="_blank"
        >ゼクシィ結婚トレンド調査2023首都圏 全国（推計値）</NuxtLink
      >
    </ParagrahNote>
    <p>
      結納式や両家の顔合わせを行うか、どのくらいの費用をかけるかは地域差が大きいため、2人だけで決めず、お互いの両親に相談するのが理想です。
    </p>
    <h3>婚約・結婚指輪の費用：平均66.3万</h3>
    <p>
      婚約指輪の平均費用は38.2万円、結婚指輪の平均費用は2人分で28.1万円です。
    </p>
    <p>
      婚約指輪をはじめとする婚約記念品の有無については、「あった」が72.5％、「なかった」が27.1％となっており、結婚資金を抑えたい場合は購入を控えるのも1つの方法かもしれません。
    </p>
    <ParagrahNote>
      参照：<NuxtLink
        href="https://souken.zexy.net/data/trend2023/XY_MT23_report_06shutoken.pdf"
        external
        target="_blank"
        >ゼクシィ結婚トレンド調査2023首都圏 全国（推計値）</NuxtLink
      >
    </ParagrahNote>
    <h3>結婚式・披露宴の費用：平均327.1万円</h3>
    <PinchImageModal :src="WeddingExpensesImg" alt="結婚式・披露宴の費用" />
    <p>
      結婚式・披露宴は結婚資金のなかでも大きな割合を占める項目で、平均費用は327.1万円でした。
    </p>
    <p>
      結婚式の招待客数の全国平均は49.1人で、ご祝儀総額の全国平均は197.8万円です。また、結婚式費用の援助総額の全国平均は163.7万円（※）でした。
    </p>
    <p>
      つまり、結婚式費用総額やご祝儀総額が平均的だった場合、<strong>実質的にかかる結婚式費用は約130万円</strong>で、両親などから援助があれば、さらに自己負担額が軽減されるイメージです。
    </p>
    <ParagrahNote>
      （※）援助があった人のうち金額回答者のみを対象とした平均額で、援助を受けていない人は計算に含まれていない。<br />
      参照：<NuxtLink
        href="https://souken.zexy.net/data/trend2023/XY_MT23_report_06shutoken.pdf"
        external
        target="_blank"
        >ゼクシィ結婚トレンド調査2023首都圏 全国（推計値）</NuxtLink
      >
    </ParagrahNote>
    <h3>新婚旅行にかかる費用：平均49.3万円</h3>
    <p>
      新婚旅行の平均費用は43.4万円で、新婚旅行のお土産代の平均費用は5.9万円なので、合計すると平均49.3万円を新婚旅行にかけていることになります。
    </p>
    <p>
      新婚旅行にかかる費用は旅行先によっても変わってきますが、行き先が未定の場合は40～50万円程度を目安に貯金計画を立てるとよいでしょう。
    </p>
    <h3>新生活にかかる費用：平均53.2万円</h3>
    <p>
      新婚生活におけるインテリア・家具の平均費用は24.4万円、家電製品の平均費用は28.8万円なので、合計すると、平均53.2万円程度の支出が発生します。
    </p>
    <p>
      ただ、すでに持っている家具・家電を利用したり、必要なものを少しずつ買い揃えたりすれば、新生活にかかる費用はある程度の調整が可能です。
    </p>
    <p>
      まずは結納から新婚旅行までにかかる費用を優先的に準備し、余力があれば新生活にかかる費用も貯めていくとよいでしょう。
    </p>
  </WhereToConsultCard>
</template>

<style lang="scss" module></style>
